import { ComponentModalConfig, ModalSize } from 'ngx-fomantic-ui';
import { IFileManagerModalContext, IListItemQueryResult } from '../../models/interface';
import { FileManagerModalComponent } from './file-manager-modal.component';

export type IFileManagerModalResult = IListItemQueryResult|IListItemQueryResult[];

export class FileManagerModal extends ComponentModalConfig<IFileManagerModalContext, IFileManagerModalResult, void> {
  constructor(context: IFileManagerModalContext) {
    super(FileManagerModalComponent, context);
    this.isClosable = true;
    this.transitionDuration = 200;
    this.isFullScreen = true;
    (this.size as any) = 'overlay';
  }
}
